import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getPortfolioItems } from '../data/portfolioData';
import { Heart, Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const PortfolioListing = () => {
  const { t } = useTranslation();

  // Get translated portfolio items
  const portfolioItems = getPortfolioItems(t);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Breadcrumb */}
      <div className="bg-gray-100 py-4">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-sm text-gray-600">
            <a href="/" className="text-blue-500 hover:underline">AP Pacific</a> &gt; {t('portfolio.breadcrumb')}
          </div>
        </div>
      </div>

      {/* Page Header */}
      <div className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">{t('portfolio.archivesTitle')}</h1>
        </div>
      </div>

      {/* Portfolio Items List */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 space-y-12">
          {portfolioItems.map((item) => (
            <article key={item.id} className="border-b border-gray-200 pb-12 last:border-b-0">
              {/* Title */}
              <h2 className="text-3xl font-bold text-gray-800 mb-6">
                {item.title}
              </h2>
              
              {/* Featured Image */}
              <div className="mb-6">
                <a href={`/portfolio-item/${item.id}`}>
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="w-full h-96 object-cover rounded-lg hover:opacity-95 transition-opacity"
                  />
                </a>
              </div>

              {/* Meta Information */}
              <div className="flex items-center justify-between mb-4 text-sm text-gray-500">
                <div className="flex items-center space-x-4">
                  <div className="flex items-center">
                    <Heart className="w-4 h-4 mr-1 text-red-500" />
                    {item.likes}
                  </div>
                  <div className="flex items-center">
                    <Calendar className="w-4 h-4 mr-1" />
                    {item.date}
                  </div>
                </div>
                <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
                  {item.category}
                </div>
              </div>

              {/* Title Link */}
              <h3 className="text-2xl font-bold mb-4">
                <a 
                  href={`/portfolio-item/${item.id}`}
                  className="text-blue-600 hover:text-blue-800 transition-colors"
                >
                  {item.title}
                </a>
              </h3>

              {/* Description */}
              <p className="text-gray-700 mb-4 leading-relaxed">
                {item.description}
              </p>

              {/* Read More Link */}
              <a
                href={`/portfolio-item/${item.id}`}
                className="inline-block text-blue-600 hover:text-blue-800 font-medium transition-colors"
              >
                {t('portfolio.readMore')}
              </a>
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PortfolioListing;